import React, { useState } from 'react';
import { Download } from 'lucide-react';

export default function DownloadGuideForm() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission and redirect
    console.log('Email submitted:', email);
    window.open('https://futur.nova-communication.com', '_blank');
    // Reset form
    setEmail('');
  };

  return (
    <div className="card max-w-4xl mx-auto">
      <div className="flex flex-col md:flex-row gap-8 items-center">
        <div className="w-full md:w-1/2">
          <img
            src="https://res.cloudinary.com/doo9fgw4x/image/upload/f_auto,q_auto/v1744790912/dfqxmgvpgb6dwrr5owul.webp"
            alt="L'ère des agents IA – le guide Nova"
            className="w-full max-w-sm mx-auto md:mx-0 rounded-xl shadow-xl"
          />
        </div>
        <div className="w-full md:w-1/2">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 transition-colors duration-300 group-hover:text-blue-400">
            Ce que l'IA va vraiment changer d'ici 2030.
          </h2>
          <p className="text-gray-300 text-lg mb-8">
            Téléchargez notre guide gratuit « L'Ère des Agents IA » et explorez 46 prédictions pour anticiper les grandes mutations à venir.
          </p>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Votre email professionnel"
              className="w-full bg-black/50 border border-gray-800 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm transition-all duration-300 hover:border-gray-700"
              required
            />
            <button
              type="submit"
              className="w-full bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 justify-center transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/20 text-sm"
            >
              Télécharger le Guide
              <Download className="w-4 h-4" />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}